import * as React from 'react';
import { useSelector } from 'react-redux';

import { Subtitle } from '../../components/Subtitle';
import { getIsExperimentalLocation, getNewbuildingInfo } from '../../selectors/newbuildingInfo';

export function SubtitleContainer() {
  const { reviewDescription } = useSelector(getNewbuildingInfo);
  const isExperimentalLocation = useSelector(getIsExperimentalLocation);

  return <Subtitle textList={reviewDescription} isExperimentalLocation={isExperimentalLocation} />;
}
